<div onsip-grid-placement-shelf>
  <div class="first-column">
    <section class="property">
      <div class="mat-body-1 property-header">Announcment name</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_VIEW_SHELF_NAME">
        {{ announcement.name }}
      </div>
    </section>
    <section class="property">
      <div class="mat-body-1 property-header">Transfer to</div>
      <div>{{ transferToText ? transferToText : "Unassigned" }}</div>
    </section>
  </div>
  <div class="second-column">
    <section class="property">
      <div class="mat-body-1 property-header">SIP address</div>
      <div>
        {{
          announcement.appAddress.address.username + "@" + announcement.appAddress.address.domain
        }}
      </div>
    </section>
    <section class="property">
      <div class="mat-body-1 property-header">Extensions</div>
      @if (announcement.extensions && announcement.extensions.length) {
      <div [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_VIEW_SHELF_EXTENSION">
        @for (extension of announcement.extensions; track extension) {
        <div>
          {{ extension | formatExtensions }}
        </div>
        }
      </div>
      } @else { No extensions added }
    </section>
  </div>
</div>
<div class="page-view-controls">
  <button
    mat-flat-button
    class="toggle-button"
    color="primary"
    (click)="togglePanel()"
    [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_VIEW_SHELF_EDIT_BTN"
  >
    {{ "ONSIP_I18N.EDIT_INFO" | translate }}
  </button>
</div>
